import type { UpsertRecentUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpsertRecentUsersDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUpsertRecentUsers = createMutationHook({
  name: 'upsertRecentUsers',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userSearchPreferences.upsertRecentUsers.mutationOptions({
      onSuccess,
    }),
  mapInput: (RecentUserIds: string[]) => ({ RecentUserIds }),
  invalidate: (trpc) => [
    trpc.frontend.userSearchPreferences.getUserSearchPreferences.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): UpsertRecentUsersMutation => ({
    insert_user_search_preferences: {
      __typename: 'user_search_preferences_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: UpsertRecentUsersDocument,
  graphqlVariables: (RecentUserIds) => ({ RecentUserIds }),
  evictFields: ['user_search_preferences'],
});
